import React, { useState } from "react";
import "./PasswordProtected.css";
import { ASSETS_URI } from "../../../config";
import Service from "../../../Action/service";
import { toast } from "react-toastify";

const PasswordProtected = ({ pdf, setisVerified }) => {
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await Service.post(`/public/unlockprotectedcollaterals`, {
                password: password,
                pdf_id: pdf?.pdfID,
                client_id: pdf?.clientID,
                pdfSlug: pdf?.pdfSlug,
            });

            if (res?.data?.success) {
                setisVerified(false);
                toast.success("PDF unlocked!");
            } else {
                toast.error(res?.data?.message || "Incorrect password");
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <div className="pp-overlay">
            <div className="pp-popup">
                <div className="pp-popup-body">
                    {/* LEFT */}
                    <div className="pp-left pp-card">
                        <h4>This document is password protected</h4>
                        <p>
                            Please enter the password shared with you to view
                            this document.
                        </p>

                        {/* 🔐 Password form moved to LEFT */}
                        <form onSubmit={handleSubmit}>
                            <div className="pp-input">
                                <input
                                    required
                                    type={show ? "text" : "password"}
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <span onClick={() => setShow(!show)}>👁</span>
                            </div>

                            <button
                                className="pp-btn"
                                type="submit"
                                style={{
                                    backgroundColor:
                                        window.__E_TT_Client?.primary,
                                }}
                            >
                                ENTER
                            </button>
                        </form>
                    </div>

                    {/* RIGHT */}
                    <div className="pp-right">
                        <div className="pp-card pp-card-right">
                            <img
                                src={
                                    pdf?.pdfcoverPath ??
                                    `${ASSETS_URI}/${pdf?.coverImage}`
                                }
                                alt="PDF"
                                className="pp-pdf"
                            />

                            {/* 📄 PDF Name below image */}
                            <h2 className="pp-pdf-name">
                                {pdf?.pdfName || pdf?.titleName || "Untitled PDF"}
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordProtected;
